// extracted by mini-css-extract-plugin
export var locationCard = "_gg-0";